import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';




class EnvioCorreo extends React.Component{
  constructor(props) {
    super(props);

    this.state = {
      correo_nombre_campo: '',
      correo_direccion_campo: '',
      correo_mensaje_campo: '',
      respuestabot: ''
    };
  }

  componentDidMount() {
    const { steps } = this.props;
    const { correo_nombre_campo, correo_direccion_campo, correo_mensaje_campo } = steps;

    const data = {
        nombre: correo_nombre_campo.value,
        correo: correo_direccion_campo.value,
        mensaje: correo_mensaje_campo.value
      };
      
      axios.post('http://127.0.0.1:8000/api/enviar-correo', data)
        .then(response =>  {
          this.setState({respuestabot:'Perfecto! Tu correo se ha enviado!'  });
          console.log(response.data)
        })
        .catch(error => {
          console.log(error)
          this.setState({respuestabot:'Lo siento, tu correo no se ha podido enviar'  });
        });

   
  }

  render() {
    const { respuestabot } = this.state;
    return (<p>{respuestabot}</p>);
  }
}

EnvioCorreo.propTypes = {
  steps: PropTypes.object,
};

EnvioCorreo.defaultProps = {
  steps: undefined,
};

export default EnvioCorreo